import { cx } from "@emotion/css";
import * as CSS from "csstype";
import React from "react";

import { createAspectRatioStyles } from "./helpers/createAspectRatioStyles";
export interface AspectRatioProps {
  ratio: number;
  children?: React.ReactNode;
  objectFit?: CSS.Property.ObjectFit;
  objectPosition?: CSS.Property.ObjectPosition;
  className?: string;
}

/**
 * Wrapper component for images, iframes, text etc.
 * It preserves content aspect ratio and eliminates layout shift - https://web.dev/cls/ when content is loading.
 * Solution based on react-aspect-ratio - https://www.npmjs.com/package/react-aspect-ratio library
 * and https://css-tricks.com/aspect-ratio-boxes/ article.
 *
 *
 * The component takes the following props:
 * - `ratio` - ratio numeric value, both width/height (e.g. 16/9) and calculated ratio (e.g. 1.5) are accepted
 *  Script for calculating image ratio is available - find more in project README
 * - `children` - content to preserve aspect ratio for
 * - `objectFit` - CSS ObjectFit property
 * - `objectPosition` - CSS ObjectPositionProperty
 * - `className`
 */

export function AspectRatio({
  ratio,
  children,
  className,
  objectFit = "cover",
  objectPosition = "center",
}: AspectRatioProps) {
  const classes = createAspectRatioStyles({ objectFit, objectPosition, ratio });
  return <div className={cx(classes.root, className)}>{children}</div>;
}
